import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ConfettiExploder"] */ "/vercel/path0/src/components/confetti-exploder.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InputWithButton"] */ "/vercel/path0/src/components/input-with-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileShareButtonPraise"] */ "/vercel/path0/src/components/mobile-share-button-praise.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/ReviewCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SendPraiseForm"] */ "/vercel/path0/src/components/send-praise-form.tsx");
